import { Title } from './Title';
import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import logo from '../assets/logo.svg';
import { Colors } from '../constants/colors';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      width: '100vw',
      height: '100vh',
      padding: '1rem'
    },
    card: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      textAlign: 'center'
    },
    logoContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center'
    },
    logoIkem: {
      height: '100px'
    },
    logoText: {
      margin: '1rem 0 0 0',
      textAlign: 'left'
    },
    logoOC: {
      display: 'flex',
      alignContent: 'center',
      flexDirection: 'column',
      fontSize: '2.125rem',
      fontWeight: 600,
      position: 'relative',
      lineHeight: 1,
      color: Colors.primary,
      paddingLeft: '3.125rem',

      '&::before': {
        content: `''`,
        width: '0.25rem',
        background: Colors.primary,
        height: '5.625rem',
        margin: '0.313rem 1.563rem',
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0
      }
    }
  })
);

export const BrowserNotSupportedWarning = () => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <div className={classes.card}>
          <div className={classes.logoContainer}>
            <img className={classes.logoIkem} src={logo} alt='IKEM logo' />
            <div className={classes.logoOC}><p className={classes.logoText}>Online<br />Connect</p></div>
          </div>
          <Title>Bohužel se tuhle aplikaci pokoušíte otevřít ve starém prohlížeči</Title>
          <p>Pro bezpečnejší a rychlejší používaní aplikace prosím použijte moderní prohližeč jako například <strong>Google Chrome</strong>.
          </p>
        </div>
      </div>
    </>
  );
};
